export default {
  id: null,
  name: '',
  email: '',
  old_password: '',
  password: '',
  password_confirmation: '',
};
